// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__e1Yr3","close":"Modal_close__BhJY3","modal-content":"Modal_modal-content__OKkK6"};